var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.63 20.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #fff;\r\n\r\nstroke-miterlimit: 10;\r\n        stroke-width: .67px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3054",
    className: "cls-1",
    d: "M9.97,19.98H3.42c-.86,0-1.57-.67-1.62-1.53l-.66-11.56c-.03-.58.43-1.08,1.02-1.08h9.07c.59,0,1.05.49,1.02,1.08l-.66,11.56c-.05.86-.76,1.53-1.62,1.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3058",
    className: "cls-1",
    d: "M11.07,1.32L1.1,3.02c-.5.09-.84.56-.75,1.06l.12.68,11.78-2.01-.12-.68c-.09-.5-.56-.84-1.06-.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3062",
    className: "cls-1",
    d: "M6.93.34l-2.26.38c-.31.05-.52.35-.46.65l.18,1.08,3.37-.58-.18-1.08c-.05-.31-.35-.52-.65-.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3066",
    className: "cls-1",
    d: "M5.96,8.64v-.57c0-.41.33-.73.73-.73s.73.33.73.73v9.52c0,.41-.33.73-.73.73s-.73-.33-.73-.73v-5.75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3070",
    className: "cls-1",
    d: "M3.92,18.32h0c-.41.02-.75-.29-.77-.69l-.53-9.51c-.02-.41.29-.75.69-.77.41-.02.75.29.77.69l.53,9.51c.02.41-.29.75-.69.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3074",
    className: "cls-1",
    d: "M9.47,18.32h0c.41.02.75-.29.77-.69l.53-9.51c.02-.41-.29-.75-.69-.77-.41-.02-.75.29-.77.69l-.53,9.51c-.02.41.29.75.69.77Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminar);
export default __webpack_public_path__ + "static/media/Eliminar.1d38c4d8db04cd94a39e0efde2b7ccbb.svg";
export { ForwardRef as ReactComponent };